"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Search = _interopRequireDefault(require("../algolia/components/Search"));

var _SearchWidget = require("@insided/destination/modules/Search/Features/SearchWidget");

var _classnames = _interopRequireDefault(require("classnames"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Search2 = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _components = require("@insided/destination/modules/Search/components");

var _resetFilters = require("@insided/destination/modules/Search/utils/resetFilters");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function shouldDisplayFilterButton() {
  var _ref, _document$querySelect;

  if (typeof window === 'undefined') return false;
  return Boolean((_ref = (_document$querySelect = document.querySelector('[data-preact="destination/modules/Navigation/WidgetCategoryFilter/index.sync"]')) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.querySelector('[data-preact="ideation-destination/filters/ProductAreaFilter"]')) !== null && _ref !== void 0 ? _ref : document.querySelector('[data-preact="ideation-destination/filters/IdeaStatusFilter"]'));
}

var MegaMenuSearch = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MegaMenuSearch, _Component);

  var _super = _createSuper(MegaMenuSearch);

  function MegaMenuSearch() {
    var _this;

    (0, _classCallCheck2.default)(this, MegaMenuSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isFiltersOverlay: false
    });
    return _this;
  }

  (0, _createClass2.default)(MegaMenuSearch, [{
    key: "revertFilters",
    value: function revertFilters(e) {
      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('revertFilters'));
      this.filtersOverlayHandler(e, false);
    }
  }, {
    key: "filtersOverlayHandler",
    value: function filtersOverlayHandler(e, value) {
      var _this2 = this;

      e.stopPropagation();
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('filter', {
        detail: {
          display: value
        }
      }));

      if (value) {
        this.setState({
          isFiltersOverlay: value
        });
      } else {
        /*
          Items that should be in the filters are added via Portal component
          having setTimeout here is making state change async and give time to filter component to unmount
        */
        window.setTimeout(function () {
          _this2.setState(function (state) {
            return {
              isFiltersOverlay: !state.isFiltersOverlay
            };
          });
        }, 0);
      }

      var bodyEl = document.querySelector('body');

      if (bodyEl) {
        if (bodyEl.style.overflow === 'hidden') {
          bodyEl.style.overflow = 'visible';
        } else {
          bodyEl.style.overflow = 'hidden';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          isUserGuest = _this$props.isUserGuest,
          extendSearch = _this$props.extendSearch,
          searchInfo = _this$props.searchInfo,
          enableFocusToSearch = _this$props.enableFocusToSearch,
          searchRevamp = _this$props.searchRevamp,
          aiSearchSummary = _this$props.aiSearchSummary,
          isGuest = _this$props.isGuest,
          aiSmartSearchEnableForAllRoles = _this$props.aiSmartSearchEnableForAllRoles,
          disableExtendedSearch = _this$props.disableExtendedSearch,
          enableExtendedSearch = _this$props.enableExtendedSearch;
      var isFiltersOverlay = this.state.isFiltersOverlay;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('header-navigation_extendable-search', {
          extended: extendSearch
        }),
        "data-bounded-context": "Search",
        "data-entity": "mega-menu"
      }, searchRevamp ? (0, _preact.h)("div", {
        className: "search-v2 no-icons-override-container"
      }, (0, _preact.h)(_SearchWidget.CollapsedSearch, (0, _extends2.default)({}, searchInfo, {
        enableFocusToSearch: enableFocusToSearch,
        callbackOnOutsideClick: disableExtendedSearch,
        aiSearchSummary: aiSearchSummary,
        isGuest: isGuest,
        aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles,
        showSearch: extendSearch,
        onShow: enableExtendedSearch
      }))) : (0, _preact.h)("div", {
        className: "old-search-wrapper"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('header-navigation_extended-search', {
          'is-hidden': !extendSearch
        })
      }, (0, _preact.h)("form", null, (0, _preact.h)(_Search.default, (0, _extends2.default)({}, searchInfo, {
        isUserGuest: isUserGuest,
        enableFocusToSearch: enableFocusToSearch,
        callbackOnOutsideClick: disableExtendedSearch
      })))), (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.show_search_bar",
        renderAsText: true
      }, function (accessibilityLabel) {
        return (0, _preact.h)("button", {
          type: "button",
          "aria-label": accessibilityLabel,
          className: (0, _classnames.default)('btn btn--secondary search-icon header-navigation_extendable-search-icon', {
            'is-hidden': extendSearch
          }),
          onClick: enableExtendedSearch,
          "data-track-type": "click",
          "data-element-name": "Search Button"
        }, (0, _preact.h)(_Search2.default, {
          width: 16,
          height: 16
        }));
      })), shouldDisplayFilterButton() && (0, _preact.h)(_components.InstantSearchFilterButton, {
        className: "is-hidden-S",
        onClick: function onClick(event) {
          return _this3.filtersOverlayHandler(event, true);
        }
      }), isFiltersOverlay && (0, _preact.h)("div", {
        className: "instant-search__results-wrapper is-hidden-L"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('instant-search__results-wrapper-filter', {
          'instant-search__results-wrapper-filter--hide': !isFiltersOverlay
        })
      }, (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-header"
      }, (0, _preact.h)(_Close.default, {
        onClick: function onClick(e) {
          return _this3.revertFilters(e);
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Close filters",
        style: {
          cursor: 'pointer'
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            _this3.revertFilters(e);
          }
        }
      }), (0, _preact.h)("h3", {
        className: "instant-search__results-wrapper-filter-header-heading"
      }, (0, _preact.h)(_phrase.default, {
        p: "advanced.search.filters"
      })), (0, _preact.h)("button", {
        onClick: _resetFilters.resetFilters,
        className: "instant-search__results-wrapper-filter-header-btn"
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "advanced.search.filter.clear.all"
      }))), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filters"
      }), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper-filter-show-more-wrapper"
      }, (0, _preact.h)(_Button.default, {
        cta: true,
        className: "instant-search__results-wrapper-filter-show-more",
        onClick: function onClick(e) {
          return _this3.filtersOverlayHandler(e, false);
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "show.results"
      }))))));
    }
  }]);
  return MegaMenuSearch;
}(_preact.Component);

var _default = MegaMenuSearch;
exports.default = _default;